
import { SubscriptionStatus } from "@/services/subscription";

interface UseLocalSubscriptionCheckProps {
  lastCheckedStatus: SubscriptionStatus | null;
  isSubscriptionActive: (status: SubscriptionStatus | null) => boolean;
  isLocallyConfirmedActive: () => boolean;
  hasCheckedSubscriptionRef: React.MutableRefObject<boolean>;
}

export const useLocalSubscriptionCheck = ({
  lastCheckedStatus,
  isSubscriptionActive,
  isLocallyConfirmedActive,
  hasCheckedSubscriptionRef
}: UseLocalSubscriptionCheckProps) => {
  const checkLocalSubscription = (): boolean => {
    const confirmedActive = isLocallyConfirmedActive();
    
    if (confirmedActive) {
      console.log('Subscription confirmed active from localStorage');
      return true;
    }

    if (hasCheckedSubscriptionRef.current && lastCheckedStatus && isSubscriptionActive(lastCheckedStatus)) {
      console.log('Previously confirmed active subscription');
      localStorage.setItem('subscription_confirmed_active', 'true');
      window.dispatchEvent(new Event('subscription_updated'));
      return true;
    }

    return false;
  };

  return { checkLocalSubscription };
};
